import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-detections',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './detections.html',
  styleUrl: './detections.scss',
})
export class Detections {
  ts = inject(TranslationService);
  t = this.ts.t;

  colors = ['#0066cc', '#00d4ff', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6'];

  detections = computed(() => [
    { name: this.t().det_person, color: this.colors[0] },
    { name: this.t().det_helmet, color: this.colors[1] },
    { name: this.t().det_vest, color: this.colors[2] },
    { name: this.t().det_glasses, color: this.colors[3] },
    { name: this.t().det_gloves, color: this.colors[4] },
    { name: this.t().det_mask, color: this.colors[5] },
    { name: this.t().det_restricted, color: this.colors[6] },
    { name: this.t().det_man_overboard, color: this.colors[7] },
    { name: this.t().det_fall, color: this.colors[0] },
    { name: this.t().det_smoke, color: this.colors[1] },
    { name: this.t().det_fire, color: this.colors[2] },
    { name: this.t().det_leak, color: this.colors[3] },
    { name: this.t().det_ladder, color: this.colors[4] },
    { name: this.t().det_suspended_load, color: this.colors[5] },
    { name: this.t().det_crane, color: this.colors[6] },
    { name: this.t().det_vehicle, color: this.colors[7] },
    { name: this.t().det_vessel, color: this.colors[0] },
    { name: this.t().det_helicopter, color: this.colors[1] },
    { name: this.t().det_gangway, color: this.colors[2] },
    { name: this.t().det_rov, color: this.colors[3] },
    { name: this.t().det_container, color: this.colors[4] },
    { name: this.t().det_open_door, color: this.colors[5] },
    { name: this.t().det_intrusion, color: this.colors[6] },
    { name: this.t().det_fatigue, color: this.colors[7] },
  ]);
}